import { render, staticRenderFns } from "./Xmlist.vue?vue&type=template&id=b8e245f6&scoped=true&"
import script from "./Xmlist.vue?vue&type=script&lang=js&"
export * from "./Xmlist.vue?vue&type=script&lang=js&"
import style0 from "./Xmlist.vue?vue&type=style&index=0&id=b8e245f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e245f6",
  null
  
)

export default component.exports